import classNames from "classnames";
import React from "react";
import classes from "./Footer.scss";

class Footer extends React.PureComponent {
  render() {
    const {
      footerComponent,
      containerStyle,
      footerContainerStyle = {},
      showNewDesign = false,
      showNewFooter = false,
    } = this.props;

    const containerClass = classNames({
      [classes.container]: !showNewDesign,
      [classes.containerV2]: showNewDesign,
    });
    return (
      <div style={footerContainerStyle} className={containerClass}>
        {showNewFooter ? (
          <div
            className={classes.footerInnerContainer}
            style={{
              ...footerContainerStyle,
            }}
          >
            {footerComponent}
          </div>
        ) : (
          <div
            className={classes.footerInnerContainer}
            style={{ ...containerStyle }}
          >
            {footerComponent}
          </div>
        )}
      </div>
    );
  }
}

export default Footer;
